import React from 'react';
import ReactDOM from 'react-dom';
import {createStore} from './store';
import AppContainer from 'react-hot-loader/lib/AppContainer';
import Root from './Root';

// Polyfills
import 'whatwg-fetch';
import 'core-js/stable';

/**
 * Main client-side entry point. This is not used during
 * server-side rendering, only after the javascript bundle
 * has been loaded into the browser.
 */

// Let webpack know where to load files from in production envs.
// This is primarily for code-splitting scenarios and for images.
if (!module.hot) {
    __webpack_public_path__ = `${window.cdnUrl}/`; // eslint-disable-line no-undef, camelcase
}

// Initial state as set by the server-side render
const initialState = window.__INITIAL_STATE__;
const siteContext = window.__SITE_CONTEXT__;

const store = createStore(initialState);

ReactDOM.render(
    <AppContainer store={store}>
        <Root store={store} siteContext={siteContext}/>
    </AppContainer>,
    document.getElementById('root')
);

// Hot module replacement in development env only
if (module.hot) {
    module.hot.accept('./Root', () => {
        const RootRequired = require('./Root').default;
        ReactDOM.unmountComponentAtNode(document.getElementById('root'));
        ReactDOM.hydrate(
            <AppContainer store={store}>
                <RootRequired store={store} siteContext={siteContext}/>
            </AppContainer>,
            document.getElementById('root')
        );
        console.log(`[HMR] Rendered at ${new Date().toLocaleTimeString()}`); // eslint-disable-line
    });
}
